import React, { useState, useEffect } from 'react';
import axios from 'axios';
import StripeCheckout from 'react-stripe-checkout';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import config from '../config';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './CheckoutForm';

// const stripePromise = loadStripe(config.STRIPE_LIVE_KEYS);
const stripePromise = process.env.REACT_APP_STRIPE_LIVE_KEYS


const RegistrationPage = () => {
  const navigate = useNavigate();
  const options = {
    // clientSecret: config.STRIPE_CLS_SECRET_KEY,
       clientSecret: process.env.REACT_APP_STRIPE_CLS_SECRET_KEY,
  };

  const location = useLocation();
  const { planId, planPrice, currencySymbol, planName } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [paymentData, setPaymentData] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [orderDetails, setOrderDetails] = useState(null);
  const [apiResponse, setResponse] = useState(null);

  // Modal state
  const [modalVisible, setModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalBody, setModalBody] = useState('');
  const [modalFooter, setModalFooter] = useState('');

  //Stripe 
  const [showCheckout, setShowCheckout] = useState(false);

  const [planDetails, setPlanDetails] = useState({
    planId: planId,
    planName: planName || '',
    price: planPrice || 0,
    oneTimeSetupFee: currencySymbol === '₹' ? 6500 : 349,
    currencySymbol: currencySymbol || '',
  });

  const [formData, setFormData] = useState({
    businessName: '',
    userName: '',
    userEmail: '',
    phone: '',
    businessType: '',
    oneTimeSetupFee: planDetails.oneTimeSetupFee || 0,
    currencySymbol: planDetails.currencySymbol || '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle phone input change
  const handlePhoneChange = (value) => {
    setFormData({ ...formData, phone: value });
  };

  const validateForm = () => {
    const errors = {};
    const whitespaceRegex = /^\s*$/; 
    if (!formData.businessName || whitespaceRegex.test(formData.businessName))  errors.businessName = 'Business name is required';
    if (!formData.userName) {
      errors.userName = 'Username is required';
    }
    if (!formData.userEmail) errors.userEmail = 'Email is required';
    if (!formData.phone) errors.phone = 'Phone number is required';
    if (!formData.agreeToTerms) errors.agreeToTerms = 'You must agree to the Privacy Policy';

    const uRegres = /\s/;
    if (formData.userName && uRegres.test(formData.userName)) {
      errors.userName = 'Username is required.';
    }

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    if (formData.userEmail && !emailRegex.test(formData.userEmail)) {
      errors.userEmail = 'Please enter a valid email address';
    }

    if (formData.phone && formData.phone.length < 10) {
      errors.phone = 'Phone number must be at least 10 digits';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  //submit signup form
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const api = config.apiBaseUrl; // Replace with your actual API URL
      await checkLogin();
      const token = localStorage.getItem('authToken');// Assuming token is stored in sessionStorage
      const url = `${api}username-check/`;

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      };

      const data = {
        username: formData.userName,
      };
      const response = await axios.post(url, data, { headers });

      if (response.status === 409) {
        toast.error("Username already exists");
        return false;
      } else {
        const { userName, businessName, userEmail, phone, currencySymbol, oneTimeSetupFee } = formData;

        setLoading(true);

        if (!validateForm()) {
          setLoading(false);
          return;
        }
        await checkLogin();
        const token = localStorage.getItem('authToken');
        const currency = currencySymbol === '₹' ? 'INR' : 'USD';
        const apiData = {
          name: businessName,
          email: userEmail,
          phone: phone,
          address: 'Enter address',
          country: currencySymbol === '₹' ? 'IN' : 'US',
          currency: currency,
          currency_symbol: currencySymbol,
          city: 'Enter city',
          state: 'Enter state',
          zip: 'Enter zip',
          nearby_zip: 'NULL',
          plan: planDetails.planId,
          restaurantUrl: '',
          status: 'ACTIVE',
          working_hours: 'Enter working hours',
          desc: 'Enter about your restaurant',
        };

        try {

          const api = config.apiBaseUrl;
          const registerResponse = await fetch(api + 'restaurant/', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Token ` + token  // Replace with actual token logic
            },
            body: JSON.stringify(apiData)
          });
          const registerData = await registerResponse.json();
          setPaymentData(registerData);
          if (registerResponse.ok && registerData.restaurant_id) {

            const orderDetails = await createOrder(token, planDetails.oneTimeSetupFee, currency);

            if (orderDetails && orderDetails.id) {
              setResponse({
                businessId: registerData.restaurant_id,
                username: userName,
                businessPhone: phone,
                businessEmail: userEmail,
                payOrderId: orderDetails.id // Ensure orderDetails.id exists
              });
              setModalTitle('<i class="fa fa-check-circle fa-lg" aria-hidden="true"></i> &nbsp; Signup Successfully');
              setModalBody(`<div>PLEASE PROCEED WITH A ONE-TIME SETUP PAYMENT OF ${formData.currencySymbol}${new Intl.NumberFormat('en-IN', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(formData.oneTimeSetupFee)} TO CREATE YOUR ADMIN ACCOUNT</div>`);
              setModalVisible(true);

            } else {

              toast.error('Order details are missing or invalid:', orderDetails);
            }

            setLoading(false);
          } else {
            setLoading(false);
            toast.error('Fail to register your business');
          }
        } catch (err) {
          setLoading(false);
          toast.error('Error while processing your registration: ' + err);
        }
        return;
      }
    } catch (error) {
      toast.error("Error checking username name:", error);
      return false; // Handle error and return default value
    }


  };


  useEffect(() => {
    async function stripeHandle() {
      const queryParams = new URLSearchParams(location.search);
      const payment_intent = queryParams.get('payment_intent');
      const payment_intent_client_secret = queryParams.get('payment_intent_client_secret');
      const redirect_status = queryParams.get('redirect_status');
      if (payment_intent && payment_intent_client_secret && redirect_status) {
        toast.success("Payment Completed successfully")
        setTimeout(() => {
          navigate('/onboarding', {
            state: {
              businessId: payment_intent,
            }
          })
        }, 3000);
        setLoading(false);
      }
    }
    stripeHandle()
  }, [])


  //api authentication token
  const checkLogin = async () => {
    const api = config.apiBaseUrl;
    const url = `${api}rest-auth/login/v1/`;
    const method = 'POST';

    const data = {
      username: 'admin',
      password: 'Mphasis8',
      restaurant_id: 1,
    };

    try {

      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      const result = await response.json();

      if (response.ok && result.token) {

        localStorage.setItem('authToken', result.token);

      } else {
        // console.log('Login failed:', result);
      }
    } catch (error) {
      // console.log('Error during login:', error);
    }
  };
  //create order id for razorpay
  const createOrder = async (token, ordAmt) => {
    const apis = config.apiBaseUrl;
    setLoading(true);
    const data = {
      amount: ordAmt, // Razorpay expects the amount in paise (1 INR = 100 paise)
      currency: 'INR',
      // receipt: 'InstaApp-One-Time-Payment',
      // partial_payment: false,
    };

    try {

      const response = await fetch(apis + 'one-time-payment/in/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ` + token,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error('Failed to create order');
      }

      const result = await response.json();
      setOrderDetails(result);
      return result;
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  //proceed payment
  const proceedToPayment = () => {
    const apis = config.apiBaseUrl;
    if (paymentData && paymentData.currency.toUpperCase() === 'INR') {
      setModalVisible(false);

      const options = {
        key: config.RAZOR_PAY_TEST_KEY,
        amount: planDetails.oneTimeSetupFee * 100,
        currency: "INR",
        name: "InstaApp",
        description: 'InstaApp One Time Payment For Order -' + apiResponse.payOrderId,
        image: "https://instaapp.online/assets/images/logo.png",
        order_id: apiResponse.payOrderId,
        prefill: {
          currency: "INR",
          name: apiResponse.username + apiResponse.businessId,
          contact: apiResponse.businessPhone,
          email: apiResponse.businessEmail
        },
        theme: {
          color: '#fc743c'
        },
        notes: {
          appname: 'InstaApp',
          paymenttype: 'One Time'
        },
        handler: async (response) => {
          // console.log("Payment Successful", response);
          const razorpayid = response.razorpay_payment_id;

          //save data after submit and create bussiness admin
          if (razorpayid) {
            try {
              const orderData = {
                plan_id: planDetails.planId,
                restaurant_id: apiResponse.businessId,
                buyer_name: apiResponse.username + '-' + apiResponse.businessId,
                buyer_email: apiResponse.businessEmail,
                paid_amount: planDetails.oneTimeSetupFee, // Replace with actual price
                paid_amount_currency: 'inr',
              };

              const api1Url = apis + 'subscriptions/';
              await checkLogin();
              const token = localStorage.getItem('authToken');

              const headers = {
                'Content-Type': 'application/json',
                'Authorization': `Token ` + token,
              };

              const orderResponse = await axios.post(api1Url, orderData, { headers });
              const orderID = orderResponse.data.id;

              if (!orderID) {
                toast.success('Payment Success! Failed to create your application. Please contact administrator!');
                setLoading(false);
                return;
              }

              // Second API call: Create admin panel for restaurant
              const adminData = {
                username: apiResponse.username,
                phone_number: apiResponse.businessPhone,
                email: apiResponse.businessEmail,
                restaurant: apiResponse.businessId,
                status: 'ACTIVE',
              };


              const api2Url = apis + 'restaurantadmin/';
              const adminResponse = await axios.post(api2Url, adminData, { headers });

              if (!adminResponse.data) {
                toast.success('Payment Success! Failed to create your admin panel. Please contact administrator!')
                setLoading(false);
                return;
              }
              toast.success("Payment Completed successfully")

              navigate('/onboarding', {
                state: {
                  businessId: apiResponse.businessId,
                }
              })
              setLoading(false);
            } catch (err) {
              console.error(err);

              toast.error('Payment Success! Failed to create your application. Please contact administrator!');
              setLoading(false);
            }
          }

        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } else {
      setModalVisible(false);
      setShowCheckout(true);
    }

  };



  // Handle form submission logic here
  const handleCheckoutSubmit = async () => {
    try {
      const apis = config.apiBaseUrl;
      const orderData = {
        plan_id: planDetails.planId,
        restaurant_id: apiResponse.businessId,
        buyer_name: apiResponse.username + '-' + apiResponse.businessId,
        buyer_email: apiResponse.businessEmail,
        paid_amount: planDetails.oneTimeSetupFee, // Replace with actual price
        paid_amount_currency: 'inr',
      };

      const api1Url = apis + 'subscriptions/';

      await checkLogin();
      const token = localStorage.getItem('authToken');

      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Token ` + token,
      };

      const orderResponse = await axios.post(api1Url, orderData, { headers });
      const orderID = orderResponse.data.id;

      if (!orderID) {
        toast.error('Payment Success! Failed to create your application. Please contact administrator!');
        setLoading(false);
        return;
      }

      // Second API call: Create admin panel for restaurant
      const adminData = {
        username: apiResponse.username,
        phone_number: apiResponse.businessPhone,
        email: apiResponse.businessEmail,
        restaurant: apiResponse.businessId,
        status: 'ACTIVE',
      };
      const api2Url = apis + 'restaurantadmin/';
      const adminResponse = await axios.post(api2Url, adminData, { headers });

      if (!adminResponse.data) {
        toast.success('Payment Success! Failed to create your admin panel. Please contact administrator!')
        setLoading(false);
        return;
      }
      setLoading(false);
      navigate('/onboarding', {
        state: {
          businessId: apiResponse.businessId,

        }
      })
    } catch (err) {

      toast.error('Payment Success! Failed to create your application. Please contact administrator!');
      setLoading(false);
    }
  };

  const handleClosePopup = () => {
    setShowCheckout(false);
  }

  return (
    <div>
      <section className="section-grey" id="pricing">
        <ToastContainer />
        <div className="container margin-top-60">
          <div className="row">
            <div className="col-md-6 padding-top-20">
              <h2>Selected Plan</h2>
              <p className="section-subtitle">
                <strong>All Plans have a one-time setup fee: {planDetails.currencySymbol}{new Intl.NumberFormat('en-IN', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(planDetails.oneTimeSetupFee)}</strong>
              </p>
              <p className='section-subtitle'>** 12 Months contract required for each plan.</p>
              <ul className='benefits margin-top-30'>
                <li><i className="fa fa-check"></i><strong>Plan Name:</strong> <b>{planDetails.planName}</b></li>
                <li><i className="fa fa-check"></i><strong>Plan Price:</strong> <b>{planDetails.currencySymbol}{new Intl.NumberFormat('en-IN', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(planDetails.price)} / per month</b></li>
              </ul>
            </div>

            <div className="col-md-6">
              <div className="register-form-wrapper wow bounceIn text-left" data-wow-delay="0.2s">
                <h2 className="text-center">Sign Up!</h2>
                <form method='POST' action="#" onSubmit={handleSubmit}>

                  <input
                    type="text"
                    className="contact-input white-input"
                    name="businessName"
                    placeholder="Business Name *"
                    // required
                    value={formData.businessName}
                    onChange={handleInputChange}
                  />
                  {formErrors.businessName && <span className='text-danger'>{formErrors.businessName}</span>}

                  <input
                    type="text"
                    className="contact-input white-input"
                    name="userName"
                    placeholder="Username *"
                    // required
                    value={formData.userName}
                    onChange={handleInputChange}
                  />
                  {formErrors.userName && <span className='text-danger'>{formErrors.userName}</span>}


                  <input
                    type="email"
                    className="contact-input white-input"
                    name="userEmail"
                    placeholder="Email Address *"
                    // required
                    value={formData.userEmail}
                    onChange={handleInputChange}
                  />
                  {formErrors.userEmail && <span className='text-danger'>{formErrors.userEmail}</span>}

                  <PhoneInput
                     country={currencySymbol === '₹' ? 'in' : 'us'}
                     preferredCountries={currencySymbol === '₹' ? ['in', 'us', 'gb'] : ['us', 'in', 'gb']}
                    value={formData.phone}
                    onChange={handlePhoneChange}
                    inputStyle={{
                      width: '100%',
                      fontSize: '16px',
                      height: '52px',
                      color: '#656565',
                      border: '1px solid #ededed',
                      backgroundColor: '#f7f8f9',
                    }}
                    containerStyle={{
                      marginBottom: '10px',
                    }}
                    dropdownStyle={{
                      position: 'absolute',
                      left: '0',
                      zIndex: 10,
                    }}
                  />
                  {formErrors.phone && <span className='text-danger'>{formErrors.phone}</span>}

                  <div className="form-group form-input margin-top-20 margin-bottom-20">
                    <input
                      className='checkboxx'
                      type="checkbox"
                      // required
                      id="agree-checkbox"
                      checked={formData.agreeToTerms || false}
                      onChange={(e) => setFormData({ ...formData, agreeToTerms: e.target.checked })}
                    />
                    <label htmlFor="agree-checkbox" style={{ marginLeft: '10px' }}>
                      I agree to the InstaApp <a href="/privacy-policy" target="_blank">Privacy Policy</a>
                    </label>
                    <br></br>
                    {formErrors.agreeToTerms && <span className='text-danger'>{formErrors.agreeToTerms}</span>}

                    <input
                      type="hidden"
                      name="oneTimeSetupFee"
                      value={planDetails.oneTimeSetupFee}
                    />
                    <input
                      type="hidden"
                      name="currencySymbol"
                      value={planDetails.currencySymbol}
                    />
                  </div>

                  <input
                    type="submit"
                    disabled={loading}
                    className="register-submit"
                    value={loading ? 'Submitting...' : 'Sign Up'}
                  />
                </form>


              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Success Modal */}
      {modalVisible && (
        <div className="modal" style={{
          display: 'block',
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '380px',
          backgroundColor: 'white',
          padding: '20px',
          boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
          borderRadius: '8px',
          zIndex: '9999',
          textAlign: 'center',
          height: '230px',
        }}>
          <div className="modal-content">
            <h5 style={{ color: '#1ec10f' }} dangerouslySetInnerHTML={{ __html: modalTitle }}></h5>
            <p dangerouslySetInnerHTML={{ __html: modalBody }}></p>
            <div dangerouslySetInnerHTML={{ __html: modalFooter }}></div>
            <button
              type="button"
              style={{
                background: '#0c75fb',
                border: 'none',
                color: '#fff',
                letterSpacing: '1px',
                cursor: 'pointer',
                display: 'inline-block',
                fontSize: '14px',
                fontWeight: '700',
                width: '100%',
                padding: '10px 0',
                textTransform: 'uppercase',
                borderRadius: '3px',
                transition: 'all .50s ease-in-out',
              }}
              onClick={proceedToPayment}
            >
              Proceed To Payment
            </button>

          </div>
        </div>
      )}

      {/* Checkout Modal */}
      {showCheckout && (
        <div className="modal" style={{
          display: 'block',
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          height: '65%',
          maxWidth: '600px',
          backgroundColor: 'white',
          padding: '20px',
          boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
          borderRadius: '8px',
          zIndex: '10000',
          textAlign: 'center',
          overflow: 'auto',
        }}>

          <div className="modal-content">
            {/* <form onSubmit={handlePaymentSuccess}> */}
            <Elements stripe={stripePromise} options={options} >
              <CheckoutForm onSubmit={handleCheckoutSubmit} closePopUp={handleClosePopup}/>
            </Elements>
            {/* <div className='d-flex mt-5 justify-content-between'>
              <button type="submit" className='register-submit' style={{width:'45%'}}>
                {loading ? 'Processing...' : 'Pay Now'}
              </button>
                <button
                  type="button"
                  style={{
                    background: '#ff5c5c',
                    border: 'none',
                    color: '#fff',
                    letterSpacing: '1px',
                    cursor: 'pointer',
                    display: 'inline-block',
                    fontSize: '14px',
                    fontWeight: '700',
                    width: '45%',
                    padding: '10px 0',
                    textTransform: 'uppercase',
                    borderRadius: '3px',
                    transition: 'all .50s ease-in-out',
                  }}
                  onClick={() => setShowCheckout(false)} // Close the checkout modal
                >
                  Cancel Payment
                </button>
              </div> */}
            {/* </form> */}

          </div>
        </div>
      )}

    </div>

  );
};

export default RegistrationPage;
